<template>
	<div id="home">
		<menuPage class="sidebar" v-if="show"></menuPage>
		<div class="content">
			<router-view class="view" element-loading-spinner="el-icon-loading"></router-view>
		</div>
	</div>
</template>

<script>
	import menuPage from '@/components/menuPage.vue';
	export default {
		name: 'home',
		components: { menuPage },
		data() {
			return {
				activeIndex: '1',
				show: true,
			}
		},
		created() {
			if(this.$route.query.sign){
				let tokenObj= JSON.stringify({token: this.$route.query.sign});
				this.show = false;
			}
		},
		methods: {}
	}
</script>
<style lang="scss" scoped>
	#home {
		height: 100vh;
		display: flex;
		background: #f0f2f8;

		.sidebar {
			flex-shrink: 0;
		}

		.content {
			flex: 1;
			display: flex;
			overflow: hidden;
			flex-direction: column;

			.view {
				flex: 1;
				overflow-y: auto;
			}
		}
	}
</style>